/**
 * Notifications selectors (PX-W6.2) — typed reads over the notifications
 * slice for the bell and the centre.
 */

import { createSelector } from '@reduxjs/toolkit'

import type { ApiNotification } from './types'
import type { NotificationsState } from './notificationsSlice'

interface WithNotifications {
  notifications: NotificationsState
}

export const selectNotificationsState = (s: WithNotifications): NotificationsState =>
  s.notifications

/** The unread count the bell renders (server `meta.unreadCount` after a fetch,
 * recomputed from rows after a live upsert — never a drifted local counter). */
export const selectUnreadCount = (s: WithNotifications): number => s.notifications.unreadCount

export const selectNotificationItems = (s: WithNotifications): ApiNotification[] =>
  s.notifications.items

export const selectNotificationsCache = (s: WithNotifications) => s.notifications.cache
export const selectNotificationsError = (s: WithNotifications) => s.notifications.error

/** The bell's popover preview: the most recent rows, unread first. */
export const selectRecentNotifications = createSelector(
  [selectNotificationItems],
  (items): ApiNotification[] =>
    [...items]
      .sort((a, b) => (b.createdAt ?? 0) - (a.createdAt ?? 0))
      .slice(0, 8)
)
